<div class="f-ac f-i p-vx2"><cdn-svg class="h-x3 w-x3" :path="image" :version="imageVersion"></cdn-svg><div class="t dark-gray m-lx2">{{ message }}</div></div>